import { render } from "./materialIcon.vue?vue&type=template&id=7ee1a531"
import script from "./materialIcon.vue?vue&type=script&lang=js"
export * from "./materialIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__